import React from 'react';

import Checkbox from './checkbox';

export default class Toggle extends Checkbox {
    static defaultProps = {
        size: '',
        checkedText: '',
        uncheckedText: ''
    }

    render() {
        return (
            <span className={'toggle ' + this.props.size + (this.checked ? ' checked' : '') + (this.props.disabled ? ' disabled' : '')} onClick={this.handleClick}>
                <span className="toggle-handle">{this.checked ? this.props.checkedText : this.props.uncheckedText}</span>
            </span>
        );
    }
}
